import { c as _c } from "react/compiler-runtime";
import { AdvisorProfileHubGate, AdvisorProfileLayout } from '@src/components/sco/Advisors/layout/AdvisorProfileLayout';
import { AdvisorApplicationSection } from '@src/components/sco/Advisors/sections/advisorApplication/AdvisorApplicationSection';

/** `/advisors/profile/edit` — jump-anywhere application forms. */
export const AdvisorProfileEditSection = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <AdvisorProfileHubGate><AdvisorProfileLayout compactHeader={true} activeKey="edit" description="Jump to any section and save when you are done." title="Edit"><AdvisorApplicationSection hidePageHeader={true} variant="manage" /></AdvisorProfileLayout></AdvisorProfileHubGate>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};